import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["list", "view", "mainCard", "bodyTable", "footerTable", "headTable", "opportunityLeadName",
                    "countOneCheckbox", "countOne", "countTwoCheckbox", "balanceHeader"]

  connect() {
    this.controllerName = `financials--books--statements--annual--index`
    this.controllerNumber = this.getControllerByIdentifier(`app--helpers--numbers`)
    this.itemsOnPage = 300
    this.pageNumber = 0
    this.numberPages = []
    this.sort = { mode: `asc`, field: `token` }
    this.hasShow = false
    this.tableCols = 14
    this.doAccounts()
  }

  doIndexListHtml() {

    var clearBtnHtml = ``

    var html = `<div class="card" style="width:100%;display:relative;" data-controller="app--helpers--search" data-${this.controllerName}-target="mainCard" data-action="resize@window->${this.controllerName}#layout">
                  
                  <div class="card-body py-0" style="overflow:auto;">
                    <div class="row">
                      <div class="col p-0">
                        <table class="table table-sm table-hover" style="font-size:80%;">
                          <thead data-${this.controllerName}-target="headTable"></thead>
                          <tbody data-${this.controllerName}-target="bodyTable"></tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div class="card-footer py-0" data-${this.controllerName}-target="footerTable">
                  </div>
                </div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(controller.getControllerByIdentifier("financials--books--statements--annual--dashboard").listTarget.innerHTML = html)
    }).then(() => {
      controller.mainCardTarget.style.height = ($(window).height() * 0.65) + "px"
      controller.bodyTableTarget.insertAdjacentHTML("beforeend", controller.getControllerByIdentifier("app--helpers--table").doTablePreloader(this.tableCols, 10))
      controller.doTableHead()
      controller.doDataTable()
    })
  }

  doTableHead() {

    this.application.dates.forEach((element, index) => {
      if (this.application.current_date.id == element.id) {
        this.application.dates.slice(index, 12 + index).forEach(element => {
          this.application.annual_balances[this.application.annual_balances.length] = element
        })
      }
    })

    var monthsHtml = ``
    
    this.application.annual_balances.forEach(element => {
      monthsHtml += `<th scope="col" class="pointer p-1 table-7 align-middle text-center">${element.date_pretty}</th>`
    })
    // style="font-size:80%;"
    
    this.headTableTarget.innerHTML = `<tr>
                                        <th colspan="2" scope="col" class="pointer p-1 align-middle table-8">
                                          Contas
                                        </th>
                                        ${monthsHtml}
                                      </tr>`

  }

  doDataTable() {
    var accountsHtml = ``

    this.accounts.forEach(accountElement => {
      accountsHtml += this.balanceTablePartial(accountElement)
    })

    this.bodyTableTarget.innerHTML = accountsHtml

  }

  balanceTablePartial(accountElement) {
    var balancesHtml = ``

    var highlight = ``
    var spaceRow = ``
    var borderHighlight = ``
    if (accountElement.highlight) {
      highlight = `f-bold`
      spaceRow = `<tr><td colspan="14" style="height:2rem;padding-top:1rem;padding-bottom:1rem;" scope="col"></td></tr>`
      borderHighlight = `border-highlight`
    }

    this.application.annual_balances.forEach(dateElement => {
      balancesHtml += `<td style="font-size:90%;" scope="col" class="p-1 align-middle text-center ${highlight}">${this.controllerNumber.currencyOptionMask(dateElement.statement_compilation[accountElement.name])}</td>`
    })

    var rowHtml = `${spaceRow}
                  <tr class="itemRow ${borderHighlight}">
                    <td colspan="2" style="font-size:100%;" scope="col" class="p-1 align-middle ${highlight}">${accountElement.name_pretty}</td>
                    ${balancesHtml}
                  </tr>
                  ${spaceRow}`

    return rowHtml
  }

  doAccounts() {
    this.accounts = [
                      {
                        name: `total_revenues`,
                        name_pretty: `Receitas`,
                        highlight: false,
                      },
                      {
                        name: `total_expenses`,
                        name_pretty: `Despesas`,
                        highlight: false,
                      },
                      {
                        name: `total_taxes`,
                        name_pretty: `Impostos`,
                        highlight: false,
                      },
                      {
                        name: `total_result`,
                        name_pretty: `Resultado`,
                        highlight: true,
                      },
                      {
                        name: `cash_and_cash_equivalents`,
                        name_pretty: `Disponibilidades`,
                        highlight: false,
                      },
                      {
                        name: `receivables`,
                        name_pretty: `À Receber`,
                        highlight: false,
                      },
                      {
                        name: `payables`,
                        name_pretty: `À Pagar`,
                        highlight: false,
                      },
                      {
                        name: `short_term_financial_obligations`,
                        name_pretty: `Financeiras Curto Prazo`,
                        highlight: false,
                      },
                      {
                        name: `short_term_taxes_and_others_obligations`,
                        name_pretty: `Impostos no Curto Prazo`,
                        highlight: false,
                      },
                      {
                        name: `long_term_financial_obligations`,
                        name_pretty: `Financeiras Longo Prazo`,
                        highlight: false,
                      },
                      {
                        name: `long_term_taxes_and_others_obligations`,
                        name_pretty: `Impostos no Longo Prazo`,
                        highlight: false,
                      },
                      {
                        name: `accrued_profit_and_loss`,
                        name_pretty: `Patrimônio Líquido`,
                        highlight: true,
                      },
                    ]
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  layout() {
    var targets = ["mainCard"]
    var identifier = ""
    // this.getControllerByIdentifier("app--helpers--layout").resizeMainCard(targets, identifier)
  }

  refreshSaveBtn() {
    var controller = this
    this.refreshTimer = setInterval(function () {
      var len = 0
      controller.validGroupTargets.forEach(element => {
        if (this.fromStringToBoolean(element.dataset.valid) == false) {
          len += 1
        }
      });
      if (len == 0) {
        controller.saveBtnTarget.disabled = false
      } else {
        controller.saveBtnTarget.disabled = true
      }
    }, 200);
  }

  stopRefreshing() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
    }
  }

  goToURL(ev) {
    var url = ev.currentTarget.dataset.url
    window.open(url, `_self`)
  }

  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  mapElements(array, field) {
    var results = []
    array.forEach(element => {
      results[results.length] = element[field]
    });
    return results
  }

  // var controller = this
  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}
